import { render, staticRenderFns } from "./BatchEditProducts.vue?vue&type=template&id=24f924a5&"
import script from "./BatchEditProducts.vue?vue&type=script&lang=js&"
export * from "./BatchEditProducts.vue?vue&type=script&lang=js&"
import style0 from "./BatchEditProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports